import { RNG } from "./rng";

export class SecureRandom {
    public static nextBytes(ba: any) {
        let rng = new RNG();
        return rng.rng_get_bytes(ba);
    }
}